"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Spinner = function (_a) {
    var _b, _c;
    var className = _a.className, container = _a.container, _d = _a.size, size = _d === void 0 ? 'medium' : _d, props = __rest(_a, ["className", "container", "size"]);
    var SpinnerClasses = classnames_1.default('Spinner', (_b = {},
        _b["" + className] = className && !container,
        _b['Spinner--large'] = size === 'large',
        _b['Spinner--medium'] = size === 'medium',
        _b['Spinner--small'] = size === 'small',
        _b['Spinner--tiny'] = size === 'tiny',
        _b));
    var CardClasses = classnames_1.default('Card__spinner', (_c = {},
        _c["" + className] = className && container,
        _c));
    var RadiusSize = {
        large: 46,
        medium: 45,
        small: 44,
        tiny: 43,
    };
    var CircleRadius = RadiusSize[size];
    var spinnerComponent = (react_1.default.createElement("div", __assign({ className: SpinnerClasses }, props),
        react_1.default.createElement("svg", { className: "Spinner__svg", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("circle", { className: "Spinner__circle", cx: "50", cy: "50", r: CircleRadius }))));
    return container ? (react_1.default.createElement(__1.Card, { className: CardClasses }, spinnerComponent)) : (spinnerComponent);
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map